<div class="p-5">
  <app-breadcrumb [items]="breadcrumbItems()" />

  <h1 class="text-2xl font-medium mb-5">{{ 'waters.pricing.breadcrumb' | translate }}</h1>

  <section>
    <h2 class="text-lg font-medium mb-2">{{ 'waters.season-periods.heading' | translate }}</h2>
    @if (waterId()) {
      <app-season-periods [waterId]="waterId()" />
    }
  </section>
</div>
